import { render, staticRenderFns } from "./score.view.vue?vue&type=template&id=bd8de492&"
import script from "./score.view.vue?vue&type=script&lang=ts&"
export * from "./score.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports